module.exports = __webpack_public_path__ + "img/stock3.57720e14.png";